<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">

                <div class="col-12 mt-4 mb-4 gifted-voucher">
                    <div class="card">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-6">
                                    <img class="img-fluid" v-bind:src="'/img/' + this.logo"  width="150" alt="Gifted PH" title="Gifted PH" />
                                </div>
                            </div>
                        </div>
                        <div class="card card-title text-center">
                            <h3>
                                Maya Redemption Page
                            </h3>

                        </div>
                        <div class="row p-3">
                            <div class="col-md-12">
                                <div class="card mb-2">
                                    <div class="card-body">
                                        <p class="font-italic">Please fill out this form to complete your Maya request . Please make sure to enter correct details as registered in your Maya profile. Transactions provided with the wrong details cannot be reversed. Your order will be processed within 3 working days excluding weekends and holidays. Thank you!</p>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-body">
                                        <form id="gcashForm">
                                            <div class="form-row">
                                                <div class="form-group col-md-6">
                                                    <label for="order_id">Gifted Order Number (Starts with 202xxx)</label>
                                                    <div class="input-group mb-3">
                                                        <input type="text" class="form-control" id="order_id" name="order_id" placeholder="Gifted Order Number" v-model="order_id">
                                                        <div class="input-group-append">
                                                            <button class="btn btn-outline-secondary" @click="verify()" type="button">Validate</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <label for="">Maya Registered Mobile Number</label>
                                                    <input type="text" class="form-control" id="mobile_number" name="mobile_number" placeholder="Mobile Number" />
                                                    <small>Start your number from 09 and must be 11 digits.</small>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-4">
                                                    <label for="">Last Name</label>
                                                    <input type="text" class="form-control" id="last_name" name="last_name" placeholder="Last Name" />
                                                </div>
                                                <div class="form-group col-md-4">
                                                    <label for="">First Name</label>
                                                    <input type="text" class="form-control" id="first_name" name="first_name" placeholder="First Name" />
                                                </div>
                                                <div class="form-group col-md-4">
                                                    <label for="">Email Address</label>
                                                    <input type="email" class="form-control" id="email_address" name="email_address" placeholder="Email Address" />
                                                </div>
                                            </div>
                                            <hr>
                                            <div class="form-row mt-4">
                                                <div class="form-group col-md-12">
                                                    <label class="pointer">
                                                        <input type="checkbox" id="agree" name="agree" class="mr-2" /> All data is secure and will be processed according to Gifted.PH Data Privacy Standards. I have read the <a href="">Privacy Policy</a>.
                                                    </label>
                                                </div>
                                            </div>

                                            <input type="hidden" name="_token" id="token">
                                        </form>

                                        <div class="form-row">
                                            <div class="form-group col-md-12">
                                                <button type="button" @click="submitUser()" class="btn btn-success btn-lg" id="btn_submit" disabled>Submit</button>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="row">
                                 <div class="col-md-12">
                                    <h2>Gifted. The Gift Giving Company</h2>
                                    <p>For more information, visit <a target="_blank" href="https://gifted.ph/">www.gifted.ph</a>.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<style scoped>
    .pointer { cursor: pointer; }
</style>
<script>
    import axios from 'axios'

    export default {
        props: [],
        data(){
            return {
                voucher_code: "",
                logo: "gifted-logo-voucher.jpg",
            }
        },
        mounted() {
            // Swal.fire({
            //     title: '📢 Holy Week Advisory',
            //     html: `
            //         <p>In observance of the Holy Week, our operations will be <strong>temporarily paused from April 17–20</strong>.</p>
            //         <p>Please expect <strong>processing and response times to be extended</strong> during this period.</p>
            //         <p>Thank you for your understanding. 🙏</p>
            //     `,
            //     icon: 'info',
            //     confirmButtonText: 'Got it!',
            //     confirmButtonColor: '#3085d6'
            // });
        },
        methods: {
            submitUser: () => {
                if($("#agree").prop("checked")){
                    var last_name = $('#last_name').val();
                    var first_name = $('#first_name').val();
                    var email_address = $('#email_address').val();
                    var mobile_number = $('#mobile_number').val();
                    var order_id = $('#order_id').val();
                    if(last_name == '' || first_name == '' || email_address == '' || mobile_number == '' || order_id == ''){
                        Swal.fire({
                            icon: 'error',
                            title: 'Please fill up all required fields.'
                        })
                    } else {
                        var regex = /^09[0-9]{9}$/;
                        if(regex.test(String(mobile_number))) {
                            Swal.fire({
                                title: 'Are you sure?',
                                text: "Please confirm the details of your Maya request, particularly the mobile number ("+mobile_number+") provided. Once loaded to this number, the transaction is final and cannot be reversed.",
                                icon: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                confirmButtonText: 'Yes, submit it!'
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    var token = $('meta[name="csrf-token"]').attr('content');
                                    $('#token').val(token);
                                    var formData = $('#gcashForm').serialize();
                                    $.ajax({
                                        type:'POST',
                                        url:'/maya/submit',
                                        data: formData,
                                        success: (result) => {
                                            if(result) {
                                                Swal.fire({
                                                        icon: 'success',
                                                        title: 'Thank you for your submission!',
                                                        text: ' The process takes 1-5 working days based on accuracy of data provided.  Please contact us at admin@gifted.ph for any questions',
                                                        allowEscapeKey : false,
                                                        allowOutsideClick: false,
                                                    }).then((result) => {
                                                        if (result.isConfirmed) {
                                                            window.location.reload();
                                                        }
                                                    })
                                            }
                                        },
                                        beforeSend: () => {
                                            Swal.fire({
                                                title: 'Processing...',
                                                html: '<div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
                                                showConfirmButton: false,
                                                allowEscapeKey : false,
                                                allowOutsideClick: false,
                                            });
                                        },
                                        error(errors) {
                                            Swal.close();
                                            const errorObj = JSON.parse(JSON.stringify(errors.responseJSON.errors));
                                            const firstFieldKey = Object.keys(errorObj)[0];

                                            Swal.fire({
                                                icon: 'error',
                                                title: 'Error',
                                                html: errorObj[firstFieldKey][0],
                                                confirmButtonText: 'Okay'
                                            });
                                        }
                                    });
                                }
                            });

                        } else {
                            Swal.fire({
                                icon: 'error',
                                title: 'Mobile number must start in 09 and should be 11 digits.'
                            })
                        }
                    }
                    
                } else {
                    Swal.fire({
                        icon: 'info',
                        title: 'Did you read and agree the Privacy Policy?'
                    })
                }
            },

            verify: () => {
var order_id = $('#order_id').val();
                var token = $('meta[name="csrf-token"]').attr('content');

                if(order_id)
                {

                    $.ajax({
                        type:'POST',
                        url:'maya/verify',
                        data: {
                            _token: $('meta[name="csrf-token"]').attr('content'),
                            order_id: order_id,
                        },
                        dataType: 'JSON',
                        success: (result) => {
                            if(result.message == 'Invalid Order ID or Order Status'){
                                 Swal.fire({
                                    icon: 'error',
                                    title: 'Invalid Order ID or Order Status'
                                })
                                $('#order_id').val('')
                                $('#brand').val('')
                                $('#amount').val('')
                                 $('#btn_submit').prop("disabled", true);
                            }
                            else if(result.message == 'Invalid Maya Order'){
                                 Swal.fire({
                                    icon: 'error',
                                    title: 'Invalid Maya Order'
                                })
                                $('#order_id').val('')
                                $('#brand').val('')
                                $('#amount').val('')
                                 $('#btn_submit').prop("disabled", true);
                            }
                            else if(result.message == 'invalidstatus'){
                                 Swal.fire({
                                    icon: 'error',
                                    title: 'Invalid Status for Order ID.'
                                })
                                $('#order_id').val('')
                                $('#brand').val('')
                                $('#amount').val('')
                                 $('#btn_submit').prop("disabled", true);
                            }
                            else if(result.message == 'used')
                            {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Order ID is already Submitted.'
                                })
                                $('#order_id').val('')
                                $('#brand').val('')
                                $('#amount').val('')
                                 $('#btn_submit').prop("disabled", true);
                            }
                            else{
                                $('#brand').val(result.brand)
                                $('#amount').val(result.amount)
                                $('#btn_submit').prop("disabled", false);
                                Swal.close();
                                Swal.fire({
                                    icon: 'success',
                                    title: 'Order Number is valid!',
                                });
                            }
                        },
                        beforeSend: () => {
                            Swal.fire({
                                title: 'Verifying...',
                                html: '<div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
                                showConfirmButton: false,
                                allowEscapeKey : false,
                                allowOutsideClick: false,
                            });
                        }
                    });
                }
                else{
                    Swal.fire({
                        icon: 'error',
                        title: 'Order ID is required'
                    })
                }
            }
        }
    }



</script>
